import { createApp } from "vue";
import AppAnon from "./AppAnon.vue";
import store from "./ts/store";
import axios from "axios";
import VueAxios from "vue-axios";
import router from "./ts/router/anon/router";
import { configureAxios } from "./ts/api/axiosConfiguration";

configureAxios();

createApp(AppAnon)
  .use(router)
  .use(store)
  .use(VueAxios, axios)
  .mount("#app");

// Set default view for local dev in partner site.
// router.isReady().then(() => {
//   if (router.currentRoute.value.path === '/') {
//     router.replace('/login')
//   }
// })
